function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 4.16667C13.9664 4.17529 13.4367 4.26299 12.9271 4.42708C13.1629 4.85589 13.2884 5.34006 13.2917 5.83333C13.2917 6.21635 13.2187 6.59563 13.077 6.94949C12.9354 7.30336 12.7277 7.62489 12.4659 7.89573C12.2041 8.16656 11.8932 8.38141 11.5512 8.52798C11.2091 8.67456 10.8425 8.75 10.4722 8.75C9.99538 8.74658 9.52736 8.61675 9.11284 8.37292C8.7858 9.54625 8.82391 10.7963 9.22179 11.946C9.61966 13.0956 10.3571 14.0867 11.3297 14.7787C12.3023 15.4707 13.4607 15.8286 14.6409 15.8017C15.821 15.7748 16.963 15.3645 17.9052 14.6288C18.8474 13.8932 19.542 12.8695 19.8905 11.7028C20.2391 10.5361 20.2239 9.28556 19.8472 8.12826C19.4706 6.97097 18.7514 5.96562 17.7917 5.25461C16.832 4.5436 15.6804 4.16298 14.5 4.16667ZM28.8248 9.23958C26.0945 3.72865 20.6892 0 14.5 0C8.3108 0 2.90401 3.73125 0.175181 9.2401C0.0600076 9.47579 0 9.73617 0 10.0003C0 10.2643 0.0600076 10.5247 0.175181 10.7604C2.90552 16.2714 8.3108 20 14.5 20C20.6892 20 26.096 16.2687 28.8248 10.7599C28.94 10.5242 29 10.2638 29 9.99974C29 9.73565 28.94 9.47526 28.8248 9.23958ZM14.5 17.5C9.53324 17.5 4.97983 14.6354 2.52086 10C4.97983 5.36458 9.53273 2.5 14.5 2.5C19.4673 2.5 24.0202 5.36458 26.4791 10C24.0207 14.6354 19.4673 17.5 14.5 17.5Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 0.251935,
  y1: 0.568111,
  x2: 30.2519,
  y2: 20.31811,
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgPasswordEyeCrossed = function SvgPasswordEyeCrossed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPasswordEyeCrossed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passwordEyeCrossed.ee41fd6a.svg";
export { ForwardRef as ReactComponent };